import { render } from "./SSOAuth.vue?vue&type=template&id=583e7d2d&scoped=true"
import script from "./SSOAuth.vue?vue&type=script&lang=js"
export * from "./SSOAuth.vue?vue&type=script&lang=js"

import "./SSOAuth.vue?vue&type=style&index=0&id=583e7d2d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-583e7d2d"]])

export default __exports__